import {
  SectionElement,
  defineElement
} from "./chunk-DNDL4K7L.js";
import {
  __decorateClass
} from "./chunk-CFQW6ARL.js";

// src/sections/shop-hero/shop-hero.ts
var ShopHero = class extends SectionElement {
  connectedCallback() {
    var _a;
    if (this.dataset.fullwidth != void 0) {
      (_a = this.parentElement) == null ? void 0 : _a.classList.add("!overflow-x-visible");
      this.classList.add("-mx-5");
    }
  }
};
ShopHero = __decorateClass([
  defineElement("shop-hero")
], ShopHero);
export {
  ShopHero
};
